import React from 'react';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardMedia from '@mui/material/CardMedia';
import Container from '@mui/material/Container';
import CardContent from '@mui/material/CardContent';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';
import FeatureDialog from 'components/feature-dialog';
import Stack from '@mui/material/Stack';
import { IFeature } from 'types/feature';
import './styles.css';

const features: IFeature[] = [
  {
    id: '1',
    image: 'package_1/pic_1.webp',
    title: 'Family Package - 1',
    subTitle: '5 Days 4 Nights',
    shortDescription:
      'Lion Rock / Dambulla / Kandy / Pinnawala / Ambuluwawa / Negombo / Colombo',
    description: `You can visit the 8th wonder of the world, "Sigiriya Lion rock" along with Dambulla golden temple (cave temple). can see the Elephant bath @Pinnawala, and visit the tooth temple of Kandy, a world's heritage site while enjoying the scenic beauty of mountainous city, tour includes visiting 14th century "Lankathilake Viharaya" famous for its marvellous architecture and famous "Ambekke devalaya" for its crafty wood carvings. Tour covers Ambuluwawa Tower too, where you can enjoy 360 degree panoramic views of scenic mountain ranges at very high altitude. Tour includes a visit to Royal Botanic garden in Peradeniya. You can experience a jungle trekking at "Udawattha Kele" a tropical wetzone forest in Kandy.\n\nYou can enjoy and relax at Negombo beach and have a city tour/shopping in Colombo too. Package includes airport transfers (both) and accommodation in Star class hotels/resorts/inns on BB basis. Package excludes Government levy/entrance fees to respective sites/tips if applicable etc.`,
    gallery: [
      'package_1/pic_2.webp',
      'package_1/pic_3.webp',
      'package_1/pic_4.webp',
      'package_1/pic_5.webp',
      'package_1/pic_6.webp',
      'package_1/pic_7.webp',
      'package_1/pic_8.webp',
      'package_1/pic_9.webp',
      'package_1/pic_10.webp',
      'package_1/pic_11.webp',
      'package_1/pic_12.webp',
      'package_1/pic_13.webp',
    ],
  },
  {
    id: '2',
    image: 'package_2/pic_1.webp',
    title: 'Family Package - 2 (Heritage)',
    subTitle: '8 Days 7 Nights',
    shortDescription:
      "Lion rock / Dambulla / Pollonnaruwa / Pasikuddah / Kandy / Pinnawala / Ambuluwawa / N'Eliya (Little England ) / Ella / Mirissa / Galle",
    description: `You can visit the 8th wonder of the world, "Sigiriya Lion rock" along with Dambulla golden temple (cave temple) 2nd Century BC, You can see the huge water tanks, water management system built by our ancient kings and many archaeological sites including famous "Gal Viharaya" 10th Century AD in Polonnaruwa, having a sea bath in Pasikuda picturesque beach/having a Safari at Kaudulla or Minneriya to see wild elephants in their natural habitats also included in this package. You can see the Elephant bath @Pinnawala (optional), and visit the tooth temple of Kandy, a world's heritage site while enjoying the scenic beauty of mountainous city, tour includes visiting 14th century "Lankathilake Viharaya" famous for its marvellous architecture and famous "Ambekke devalaya" for its crafty wood carvings. Tour covers Ambuluwawa Tower too, where you can enjoy 360-degree panoramic views of scenic mountain ranges at very high altitude. Tour includes a visit to Royal Botanic Garden in Peradeniya. You can experience jungle trekking at "Udawattha Kele" a tropical wet zone forest in Kandy.\n\nVisiting lush green up country tea gardens and tea factory visit at Labukele, visiting picturesque Ramboda water fall or Bomburuella water fall with trekking and staying a day in Nuwara Eliya (Little England) in cool climes also includes in this package. Climbing mini-Adams peak, Ravana mega zip line, Nine Arch Bridge, Ravan Ella are main tourist attractions in Ella.\n\nYou can enjoy and relax on the golden beaches in Mirissa and visiting Galle Fort, 1500 AD Package includes airport transfers (both) and accommodation in Star class hotels/resorts/inns on BB basis. Package excludes Government levy/entrance fees to respective sites/tips if applicable etc.`,
    gallery: [
      'package_2/pic_2.webp',
      'package_2/pic_3.webp',
      'package_2/pic_4.webp',
      'package_2/pic_5.webp',
      'package_2/pic_6.webp',
      'package_2/pic_7.webp',
      'package_2/pic_8.webp',
      'package_2/pic_9.webp',
      'package_2/pic_10.webp',
      'package_2/pic_11.webp',
      'package_2/pic_12.webp',
      'package_2/pic_13.webp',
      'package_2/pic_14.webp',
      'package_2/pic_15.webp',
    ],
  },
  {
    id: '3',
    image: 'package_3/pic_1.webp',
    title: 'Family Package - 3 (Heritage+)',
    subTitle: '12 Days 11 Nights',
    shortDescription: `Lion rock / Dambulla / Anuradhapura / Mihintale / Polonnaruwa / Pasikuda / Kandy / Pinnawala / Ambuluwawa/ N' Eliya/ Horton Plains ( world's end) / Ella / Yala safari / Mirissa / Galle / Bentota`,
    description: `You can visit the 8th wonder of the world, "Sigiriya Lion rock" along with Dambulla golden temple (cave temple) 2nd CenturyBC,  You can see the huge water tanks, water management system built by our ancient kings and many archaeological sites including  famous "Gal Viharaya" 10th Century AD in Polonnaruwa, having a sea bath in Pasikuddah picturesque beach / having a Safari at Kavudulla or Minneriya to see wild elephants in their natural habitats also included in this package. This tour covers our ancient city of Anuradhapura (2nd century  BC)  You can see our magnificent heritage sites and the secred "Sri Maha Bodiya" the world's oldest living tree with 2500 yrs+ history, Mihintale and visiting large water tanks (Wewa's) too included in this package. You can see the Elephant bath @Pinnawala (optional), and visit the tooth temple of Kandy, a world's heritage site while enjoying the scenic beauty of mountainous city, tour includes visiting 14th century "Lankathilake Viharaya" famous for its marvellous architecture and famous "Ambekke devalaya" for its crafty wood carvings. Tour covers Ambuluwawa Tower too, where you can enjoy 360 degree panoramic views of scenic mountain ranges at very high altitude. Tour includes a visit to picturesque Royal Botanic garden in Peradeniya. You can experience a jungle trekking at "Udawattha Kele" a tropical wetzone forest in Kandy.\n\nVisiting lush green up country tea gardens and tea factory visit at Labukele, visiting picturesque Ramboda water fall or Bomburuella water fall with trekking and staying a 2 days in Nuwara Eliya (Little England) in cool climes, visiting Horton plains (World's End) also includes in this package.  Climbing of mini Adams peak, Ravana mega zip line, Nine arch Bridge, Ravan Ella are main tourist attractions in Ella. Having a Wild Life Safari in Yala National Park too included in this package.\n\nYou can enjoy and relax on the golden pristine beaches in Mirissa and visiting Galle Fort, 1500 AD and visiting Madu Ganga boat safari, where you can enjoy in Mangroves eco system, having water jet skiing in Bentota lagoon (optional) also included in this package. Package includes airport transfers (both) and accommodation in Star class hotels/resorts/inns on BB basis. Package excludes Government levy/entrance fees to respective sites/out sourced safari vehicle charges/tips if applicable etc.`,
    gallery: [
      'package_3/pic_2.webp',
      'package_3/pic_3.webp',
      'package_3/pic_4.webp',
      'package_3/pic_5.webp',
      'package_3/pic_6.webp',
      'package_3/pic_7.webp',
      'package_3/pic_8.webp',
      'package_3/pic_9.webp',
      'package_3/pic_10.webp',
      'package_3/pic_11.webp',
      'package_3/pic_12.webp',
      'package_3/pic_13.webp',
      'package_3/pic_14.webp',
      'package_3/pic_15.webp',
      'package_3/pic_16.webp',
      'package_3/pic_17.webp',
    ],
  },
  {
    id: '4',
    image: 'package_4/pic_1.webp',
    title: 'Family Package - 4',
    subTitle: '8 Days 7 Nights',
    shortDescription:
      'Explore the northern Sri Lanka\nAnuradhapura / Jaffna / Trincomalee / Lion rock / Dambulla / Kalpitiya',
    description: `You can visit the 8th wonder of the world, "Sigiriya Lion rock" along with Dambulla golden temple (cave temple) 2nd CenturyBC, You can see the huge water tanks, water management system built by our ancient kings and many archaeological sites including famous "Gal Viharaya" 10th Century AD in Polonnaruwa, having a Safari at Kavudulla or Minneriya to see wild elephants in their natural habitats also included in this package. This tour covers our ancient city of Anuradhapura (2nd century  BC)  You can see our magnificent heritage sites and the secred "Sri Maha Bodiya" the world's oldest living tree with 2500 yrs+ history,  Mihintale and visiting large water tanks (Wewa's) too.\n\nVisiting natural harbour city of Trincomalee and relaxing on Nilaveli beach, Pigeon Island boat safari with experience of scuba diving there (optional) too included in this package. You can visit the famous rock temple at Koneshwaram and enjoy the panoramic view of the picturesque Eastern sea and Trincomalee natural harbour from high altitude. Visiting Jaffna peninsula (Northern Sri Lanka) Jaffna Dutch Fort, Hammon Hill Fort, Kasuarina beach, Visiting famous "Nallur temple" and having a boat tour to "Nagdveep" (Nainathive Island) too included in this package.\n\nYou can enjoy and relax on the golden pristine beaches in Kalpitiya and watching Dolphins, Kite surfing. Package includes airport transfers (both) and accommodation in Star class hotels/resorts/inns on BB basis. Package excludes Government levy/entrance fees to respective sites/out sourced safari vehicle or boat charges/tips if applicable etc.`,
    gallery: [
      'package_4/pic_2.webp',
      'package_4/pic_3.webp',
      'package_4/pic_4.webp',
      'package_4/pic_5.webp',
      'package_4/pic_6.webp',
      'package_4/pic_7.webp',
      'package_4/pic_8.webp',
      'package_4/pic_9.webp',
      'package_4/pic_10.webp',
      'package_4/pic_11.webp',
      'package_4/pic_12.webp',
      'package_4/pic_13.webp',
    ],
  },
  {
    id: '5',
    image: 'package_5/pic_1.webp',
    title: 'Family Package - 5',
    subTitle: '10 Days 9 Nights',
    shortDescription:
      'Relaxing on the golden beaches\nLion Rock / Dambulla / Arugambe / Yala / Unawatuna / Galle / Hikkaduwa / Colombo',
    description: `You can visit the 8th wonder of the world, "Sigiriya Lion rock" along with Dambulla golden temple (cave temple) 2nd CenturyBC, You can see the huge water tanks, water management system built by our ancient kings and many archaeological sites including famous "Gal Viharaya" 10th Century AD in Polonnaruwa, having a sea bath in Pasikuddah picturesque beach/having a Safari at Kavudulla or Minneriya to see wild elephants in their natural habitats also included in this package.\n\nRelaxing with surfing in the golden beaches in Arugambe,\n\nHaving a Wild Life Safari in Yala National Park too included in this package.\n\nYou can enjoy and relax on the golden pristine beaches in Mirissa or Hikkaduwa and visiting Galle Fort, 1500 AD and visiting Madu Ganga boat safari, where you can enjoy in Mangroves eco system, having water jet skiing in Bentota lagoon (optional) also included in this package. Package includes airport transfers (both) and accommodation in Star class hotels/resorts/inns on BB basis. Package excludes Government levy/entrance fees to respective sites/out sourced safari vehicle/boat charges etc/tips if applicable etc.ex`,
    gallery: [
      'package_5/pic_2.webp',
      'package_5/pic_3.webp',
      'package_5/pic_4.webp',
      'package_5/pic_5.webp',
      'package_5/pic_6.webp',
      'package_5/pic_7.webp',
      'package_5/pic_8.webp',
      'package_5/pic_9.webp',
      'package_5/pic_10.webp',
      'package_5/pic_11.webp',
      'package_5/pic_12.webp',
      'package_5/pic_13.webp',
    ],
  },
  {
    id: '6',
    image: 'package_6/pic_1.webp',
    title: 'Family Package - 6',
    subTitle: '8 Days 7 Nights',
    shortDescription: `Exploring the scenic beauty of Central Highlands\nKandy / Pinnawala / Ambuluwawa / Adams peak / N' Eliya / Horton plains / Ella / Uda walawe / Colombo`,
    description: `Visiting Pinnawala Elephant Orphanage to see heard of Elephants taking bath in "Ma Oya", Spice garden visit (optional) and visit the tooth temple of Kandy, a world's heritage site while enjoying the scenic beauty of mountainous city, tour includes visiting 14th century "Lankathilake Viharaya" famous for its marvellous architecture and famous "Ambekke devalaya" for its crafty wood carvings. Tour covers Ambuluwawa Tower too, where you can enjoy 360 degree panoramic views of scenic mountain ranges at very high altitude. Tour includes a visit to picturesque Royal Botanic garden in Peradeniya. You can experience a jungle trekking at "Udawattha Kele" a tropical wetzone forest in Kandy.\n\nVisiting famous Adams peak (7360ft above sea level) observing the scenic Sun rise from the peak (optional),\n\nVisiting lush green up country tea gardens and tea factory visit, visiting picturesque Bomburuella water fall with trekking (optional), visiting  Moon plains and staying 3 days in Nuwara Eliya (Little England) in cool climes, visiting Hakgala Botanic garden, visiting Horton plains (World's End) also includes in this package. Climbing of mini Adams peak, Ravana mega zip line, Nine arch Bridge, Ravan Ella are main tourist attractions in Ella. Having a Wild Life Safari in Udawalwe National Park too included in this package.\n\nPackage includes airport transfers (both) and accommodation in Star class hotels/resorts/inns on BB basis. Package excludes Government levy/entrance fees to respective sites/out sourced safari vehicle charges/tips if applicable etc.`,
    gallery: [
      'package_6/pic_2.webp',
      'package_6/pic_3.webp',
      'package_6/pic_4.webp',
      'package_6/pic_5.webp',
      'package_6/pic_6.webp',
      'package_6/pic_7.webp',
      'package_6/pic_8.webp',
      'package_6/pic_9.webp',
      'package_6/pic_10.webp',
      'package_6/pic_11.webp',
      'package_6/pic_12.webp',
      'package_6/pic_13.webp',
      'package_6/pic_14.webp',
      'package_6/pic_15.webp',
      'package_6/pic_16.webp',
    ],
  },
  {
    id: '7',
    image: 'package_7/pic_1.webp',
    title: 'Family Package - 7 (Economy)',
    subTitle: '7 Days 6 Nights',
    shortDescription: `Lion Rock / Dambulla / Kandy / Pinnawala / Ella / Mirissa / Galle`,
    description: `You can visit the 8th wonder of the world, "Sigiriya Lion rock" along with Dambulla golden temple (cave temple) 2nd CenturyBC, You can see the huge water tanks, water management system built by our ancient kings and many archaeological sites including famous "Gal Viharaya" 10th Century AD in Polonnaruwa, having a sea bath in Pasikuddah picturesque beach/having a Safari at Kavudulla or Minneriya to see wild elephants in their natural habitats also included in this package.\n\nYou can see the Elephant bath @Pinnawala, and visit the tooth temple of Kandy, a world's heritage site while enjoying the scenic beauty of mountainous city, tour includes visiting 14th century  "Lankathilake Viharaya" famous for its marvellous architecture and famous "Ambekke devalaya" for its crafty wood carvings. Tour covers Ambuluwawa Tower too, where you can enjoy 360 degree panoramic views of scenic mountain ranges at very high altitude. Tour includes a visit to picturesque Royal Botanic garden in Peradeniya. You can experience a jungle trekking at "Udawattha Kele" a tropical wetzone forest in Kandy.\n\nVisiting lush green up country tea gardens and tea factory visit at Labukele, visiting picturesque Ramboda water fall or Bomburuella water fall with trekking and staying a 2 days in Nuwara Eliya (Little England) in cool climes, visiting Horton plains (World's End) also includes in this package. Climbing of mini Adams peak, Ravana mega zip line, Nine arch Bridge, Ravan Ella are main tourist attractions in Ella. Having a Wild Life Safari in Yala National Park too included in this package.\n\nYou can enjoy and relax on the golden pristine beaches ⛱️ in Mirissa and visiting Galle Fort, 1500 AD. Package includes airport transfers (both) and accommodation in Star class hotels/resorts/inns on BB basis. Package excludes Government levy/entrance fees to respective sites/out sourced safari vehicle charges/tips if applicable etc.`,
    gallery: [
      'package_7/pic_2.webp',
      'package_7/pic_3.webp',
      'package_7/pic_4.webp',
      'package_7/pic_5.webp',
      'package_7/pic_6.webp',
      'package_7/pic_7.webp',
      'package_7/pic_8.webp',
      'package_7/pic_9.webp',
      'package_7/pic_10.webp',
      'package_7/pic_11.webp',
      'package_7/pic_12.webp',
      'package_7/pic_13.webp',
    ],
  },
  {
    id: '8',
    image: 'package_8/pic_1.webp',
    title: 'My own Tour itinerary',
    shortDescription: `This facility allow you to select your own interest of places  and select your preferences in lodging and number of days out of the given sites or else you may propose your preferred places of visit/stay. We arrange you a memorable holiday with utmost safety to match your wallet.`,
    description: `Western Province: \n1. Seethawaka Wetland Park + Visiting a picturesque waterfall\n2. Colombo City tour\nGangaramaya temple, Lotus tower, National Museum, National Zoological Garden, Parliament & Diyatha Uyana + Shopping (Optional)\n\nSabaragamuwa Province:\nWhite Water Rafting in Kithulgala + Visiting picturesque Kahanawita waterfall + River bath @ Kuthulgala\nExplore Sinharaja Tropical Rain Forest, a UNESCO  heritage site.\n\nSouthern Province:\n1. Kaneliya Tropical wet zone forest / Natural pool\n2. The Blow hole "Hummanaya", Kudawella + Wevurukannala Ancient temple + Dondra Light house\n3.Hambantota Safari zoo + Bundala bird sanctuary\n4. Hikkaduwa Coral reef boat safari in glass bottom boats + Madhu ganga boat safari (Mangroves eco system) + Visit to a Turtle hatchery (optional)\n\nNorth Western Province:\n1. Mundalama Bird sanctuary + Visiting a wind farm in Puttalam (optional) + famous "Thalawila church" + Kalpitiya Dutch fort\n2. Munneshwaram Hindu temple + Yapahuwa archaeological sites, etc.\n3. Wilpatthu Wildlife Safari\n\nCentral Province :\n1. Riverston / Memure / Mini World's End  (Pitawala pathana) Knuckles range\n2. Waterfall tour: Dunhinda fall, Badulla + Diyaluma fall + Ravana Ella + Bambarakanda fall (optional)+Lipton seat in Dambetenna you can enjoy the scenic 360 view  from very high altitude and viewing Sunrise is possible if weather is clement (Stay in Haputale) 2 nights 3 day\nJungle trekking to Scenic Idalgashinna from Adishem bungalow  (optional)\nYou may extend the tour to Horton plains thru Ohiya (Optional)\n\nEastern Province:\n1. Kumana bird sanctuary + Arugambe beach\n2. Ampara : Buddangala rock temple + Visiting Inginiyagala and Senanayake reservoirs\nDambana aboriginal village (Veddha Community) + Visiting  Victoria reservoir dam you may extend the tour via Kandy\n\nNorth Central Province:\n1. Dedicated Archaeological sites tour covering Anuradhapura, Mihintale, Ritigala, Sigiriya, Dambulla, Polonnaruwa\n\nNorthern Province:\n1. Jaffna tour:\nVisiting Nallur temple, Jaffna museum, Jaffna Dutch Fort, Famous Library, Hammon hill Fort, Kasuarina Beach.\nVisiting the islands of Jaffna  including boat rides to Nagdveep " Nainativu", boat ride to Delft is optional. This package includes visiting of Point Pedro (Northern most point of Sri Lanka) Velvetithurei lime stone beach, Picturesque Elephant pass, etc.\n3 Nights / 4 days\n\nPlease send your duly completed request to get the approx. cost of your tour.\n\n# intended dates of travel\n# persons and their ages as of the travel date\n# Nights\n# main sites (in case of "my own itinerary")\n# accommodation preferences\nHotel/ inn/ home stay\n* Guaranteed travel sustainable accommodation with safety and value for money guaranteed with our recommended places of lodging including Western breakfast and swimming pool facilities in most of the places.\n# Bed preferences\n# Room preferences\nSingle/Double/Triple/Family Room/Apartment/Shales,\n# I need the cost of the tour in (LKR/USD/EUR/AUD/......)\n\nWE PROVIDE LUXURY TRAVEL FRIENDLY VEHICLES WITH SRI LANKA TOURISM DEVELOPMENT AUTHORITY LICENCED PROFESSIONAL, ENGLISH SPEAKING CHAUFFEURS FOR ALL THE TRANSFERS FROM AND RETURN TO THE AIRPORT.`,
    gallery: [
      'package_8/pic_2.webp',
      'package_8/pic_3.webp',
      'package_8/pic_4.webp',
      'package_8/pic_5.webp',
      'package_8/pic_6.webp',
      'package_8/pic_7.webp',
      'package_8/pic_8.webp',
      'package_8/pic_9.webp',
      'package_8/pic_10.webp',
      'package_8/pic_11.webp',
      'package_8/pic_13.webp',
      'package_8/pic_14.webp',
      'package_8/pic_15.webp',
      'package_8/pic_16.webp',
      'package_8/pic_17.webp',
      'package_8/pic_18.webp',
      'package_8/pic_19.webp',
      'package_8/pic_20.webp',
      'package_8/pic_21.webp',
      'package_8/pic_22.webp',
      'package_8/pic_23.webp',
      'package_8/pic_25.webp',
      'package_8/pic_26.webp',
      'package_8/pic_27.webp',
      'package_8/pic_28.webp',
      'package_8/pic_29.webp',
      'package_8/pic_30.webp',
      'package_8/pic_31.webp',
      'package_8/pic_32.webp',
      'package_8/pic_33.webp',
      'package_8/pic_34.webp',
      'package_8/pic_35.webp',
      'package_8/pic_36.webp',
      'package_8/pic_37.webp',
      'package_8/pic_38.webp',
      'package_8/pic_39.webp',
      'package_8/pic_40.webp',
      'package_8/pic_41.webp',
      'package_8/pic_42.webp',
      'package_8/pic_43.webp',
      'package_8/pic_44.webp',
      'package_8/pic_45.webp',
      'package_8/pic_47.webp',
      'package_8/pic_48.webp',
      'package_8/pic_49.webp',
      'package_8/pic_50.webp',
      'package_8/pic_51.webp',
      'package_8/pic_52.webp',
      'package_8/pic_53.webp',
      'package_8/pic_54.webp',
      'package_8/pic_55.webp',
      'package_8/pic_56.webp',
    ],
  },
];

interface ICardItem {
  feature: IFeature;
  onClick: (feature: IFeature) => void;
}

const CardItem: React.FC<ICardItem> = ({ feature, onClick }) => (
  <Card sx={{ height: '100%' }}>
    <CardActionArea
      onClick={(event) => {
        onClick(feature);
      }}
      sx={{ height: 'inherit' }}
    >
      <Stack direction="column" sx={{ height: 'inherit' }}>
        <CardMedia
          sx={{ height: 230 }}
          image={`/images/${feature.image}`}
          title={feature.title}
        />
        <CardContent>
          <Typography gutterBottom variant="h5" component="div">
            {feature.title}
          </Typography>
          {!!feature?.subTitle && (
            <Chip
              color="primary"
              size="small"
              label={feature.subTitle}
              variant="outlined"
              sx={{ marginBottom: 1 }}
            />
          )}
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ whiteSpace: 'pre-wrap' }}
          >
            {feature.shortDescription}
          </Typography>
        </CardContent>
      </Stack>
    </CardActionArea>
  </Card>
);

const FeaturePanel: React.FC = () => {
  const [selectedItem, setSelectedItem] = React.useState<IFeature | null>(null);

  const handleClick = (item: IFeature) => {
    setSelectedItem(item);
  };

  const handleClose = () => {
    setSelectedItem(null);
  };

  return (
    <Container maxWidth="lg" sx={{ marginTop: 5, marginBottom: 10 }}>
      <Typography
        gutterBottom
        variant="h3"
        sx={{ marginBottom: 5 }}
        className="title"
      >
        Packages
      </Typography>
      <Grid container spacing={6}>
        {features.map((item) => (
          <Grid key={item.id} item sm={12} md={6} lg={4}>
            <CardItem feature={item} onClick={handleClick} />
          </Grid>
        ))}
      </Grid>
      <FeatureDialog feature={selectedItem} onClose={handleClose} />
    </Container>
  );
};

export default FeaturePanel;
